<template scope>
  <div>
    <div class="steps-page-wioa">
      <PageSteps
        v-for="(step, index) in stepObjects"
        :key="index"
        :totalSteps="Object.values(stepObjects).length"
        :stepNumber="index + 1"
        :currentStep="currentPage"
        :data="{}"
        :stepRouteName="step.routePage"
      />
    </div>
    <div class="ts-app-wioa">
      <slot />
    </div>
  </div>
</template>

<script>
import PageSteps from "@/components/PageSteps.vue";
export default {
  name: "RegistrationQuestionnaire",
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      stepObjects: [
        {
          routePage: "RegistrationQuestionnaireOne",
        },
        {
          routePage: "RegistrationQuestionnaireTwo",
        },
        {
          routePage: "RegistrationQuestionnaireThree",
        },
        {
          routePage: "RegistrationQuestionnaireFour",
        },
        {
          routePage: "RegistrationQuestionnaireFive",
        },
        {
          routePage: "RegistrationQuestionnaireSix",
        },
        {
          routePage: "RegistrationQuestionnaireSeven",
        }
      ],
    };
  },
  components: { PageSteps },
};
</script>

<style lang="scss">
@import "@/assets/scss/project/wioa.scss";
</style>
